var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpportunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.1,69H28.9c-1,0-1.9,0.9-1.9,1.9V71c0,3.3,2.7,6,6,6h34c3.3,0,6-2.7,6-6v-0.1C73,69.9,72.1,69,71.1,69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76,28c-3.3,0-6,2.7-6,6c0,1.8,0.8,3.5,2.1,4.6c-1.7,3.9-5.6,6.6-10.2,6.4c-5.3-0.3-9.6-4.6-9.9-9.9 c0-0.9,0-1.7,0.2-2.5c2.2-0.9,3.8-3,3.8-5.6c0-3.3-2.7-6-6-6c-3.3,0-6,2.7-6,6c0,2.5,1.6,4.7,3.8,5.6c0.2,0.8,0.2,1.6,0.2,2.5 c-0.3,5.3-4.6,9.6-9.9,9.9c-4.6,0.3-8.6-2.5-10.2-6.4c1.3-1.1,2.1-2.8,2.1-4.6c0-3.3-2.7-6-6-6c-3.3,0-6,2.7-6,6s2.7,6,6,6 c0,0,0,0,0,0l2.8,21.4c0.1,0.9,0.9,1.6,1.9,1.6h42.6c0.9,0,1.7-0.7,1.9-1.6L76,40c0,0,0,0,0,0c3.3,0,6-2.7,6-6S79.3,28,76,28z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunity);
export default __webpack_public_path__ + "static/media/opportunity.da230a6ce4b77e0f4ad00cb1bb133788.svg";
export { ForwardRef as ReactComponent };